/**
 * useSimulator Hook - Logic Layer
 * Handles credit simulation mutation and result state
 */

import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { simulateCredit } from '@/services/credit-engine.service';
import type { SimulatorRequest, SimulatorResponse } from '@/types/policy.types';
import { useToast } from '@/hooks';

export function useSimulator() {
  const toast = useToast();
  const [result, setResult] = useState<SimulatorResponse | null>(null);

  const mutation = useMutation({
    mutationFn: (data: SimulatorRequest) => simulateCredit(data),
    onSuccess: (response) => {
      setResult(response.data);
      toast.success('Simulacion completada');
    },
    onError: () => {
      toast.error('Error al ejecutar la simulacion');
    },
  });

  function simulate(data: SimulatorRequest) {
    mutation.mutate(data);
  }

  function reset() {
    setResult(null);
    mutation.reset();
  }

  return {
    result,
    isSimulating: mutation.isPending,
    isError: mutation.isError,
    simulate,
    reset,
  };
}
